// Dữ liệu mẫu Mint-Partner (hồ sơ nhà cung cấp, 1536) · script board `PD`. Chỉ đọc, không có tiền.
import type {} from '@hana/data';

export interface Partner {
  /** ShortName, khoá của đối tác */
  id: string;
  mst: string;
  name: string;
  roles: string[];
  type: string;
  approved: boolean;
  carrier: boolean;
  /** điều khoản: net N ngày | chốt ngày */
  payT: 'net' | 'day';
  net: string;
  /** job dùng đối tác 90 ngày */
  jobs: number;
  dup?: boolean;
  contacts: number;
  banks: { bank: string; verified: boolean }[];
}

export const PARTNERS: readonly Partner[] = [
  { id: 'YANGMING', mst: '0313•••562', name: 'YANG MING (VIETNAM) CORPORATION', roles: ['Supplier'], type: 'CARRIER', approved: true, carrier: true, payT: 'net', net: '7', jobs: 38, contacts: 2, banks: [{ bank: 'VCB · Vietcombank', verified: true }, { bank: 'TCB · Techcombank', verified: true }] },
  { id: 'VTHAILONG', mst: '0315•••912', name: 'HAI LONG TRANSPORT TRADING DEVELOPMENT INVEST', roles: ['Supplier'], type: '', approved: true, carrier: false, payT: 'day', net: '30', jobs: 21, contacts: 2, banks: [{ bank: 'ACB · ACB', verified: false }] },
  { id: 'SACKYHAIDANG', mst: '0311•••885', name: 'EUROFINS SAC KY HAI DANG COMPANY LIMITED', roles: ['Supplier'], type: '', approved: true, carrier: false, payT: 'net', net: '15', jobs: 6, contacts: 1, banks: [{ bank: 'Mã thanh toán trên DN', verified: true }] },
  { id: 'ZALO', mst: '0318•••678', name: 'ZALO PLATFORMS COMPANY LIMITED', roles: ['Supplier'], type: 'OTHER', approved: false, carrier: false, payT: 'net', net: '0', jobs: 0, dup: true, contacts: 0, banks: [] },
];

export interface TodoItem { k: string; who: string; due: string; tone: 'warn' | 'err'; act: string }
export interface PartnerView {
  todo: TodoItem[];
  legal: [string, string][];
  info: [string, string, 'warn'?][];
  roleChips: { k: string; pri: boolean; warn?: boolean }[];
  use: [string, string][];
  perf: { month: string; n: number }[];
  perfKpi: { k: string; v: string; delta?: string; up?: boolean }[];
  history: { k: string; who: string; when: string; tone: 'ok' | 'warn' | 'lb' }[];
  links: { k: string; d: string; ext: boolean }[];
  people: [string, string][];
  /** tab Liên hệ: tên, chức vụ, cờ nhận thư (nhãn) */
  contactRows: { name: string; pos: string; flags: string }[];
  /** tab Tài khoản nhận tiền: số tài khoản che 4 số cuối */
  bankRows: BankRow[];
  /** tab Local charge: bộ phí của hãng (chỉ CARRIER) */
  lccSets: { code: string; d: string }[];
  /** tab Tài khoản cổng: tên cổng, địa chỉ, tên đăng nhập (mật khẩu không có trong dữ liệu) */
  portalRows: { k: string; url: string; user: string }[];
  /** tab Wiki & tệp: ghi chú nghiệp vụ + thư viện tệp (board: chỉ YANGMING có dữ liệu mẫu) */
  wikiNotes: { title: string; body: string; meta: string }[];
  wikiFiles: { name: string; kind: string; size: string; meta: string }[];
}

export interface BankRow { bank: string; pur: string; def: boolean; no: string; mode: string; holder: string; verified: boolean; vs: string; vsTip: string; canVerify: boolean; canDef: boolean }

type BankSrc = { bank: string; no: string; deposit?: boolean; perDn?: boolean; def: boolean; vby?: string; by: string };
const BK_ROWS: Record<string, BankSrc[]> = {
  YANGMING: [{ bank: 'VCB · Vietcombank', no: '0071000004521', def: true, vby: 'NGOCANH · 02/Oct/2026', by: 'HẠNH' }, { bank: 'TCB · Techcombank', no: '1903300008877', deposit: true, def: false, vby: 'NGOCANH · 02/Oct/2026', by: 'HẠNH' }],
  VTHAILONG: [{ bank: 'ACB · ACB', no: '2468100003390', def: true, by: 'HẠNH' }],
  SACKYHAIDANG: [{ bank: 'Mã thanh toán trên DN', no: '', perDn: true, def: true, vby: 'NGOCANH · 18/Sep/2026', by: 'HẠNH' }],
};
const maskNo = (no: string) => (no ? `•••• ${no.slice(-4)}` : '—');
const deAccent = (t: string) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D');

const CT_ROWS: Record<string, [string, string, string][]> = {
  YANGMING: [['Bộ phận Booking', 'Booking · CS', 'Xác nhận booking · Arrival notice'], ['Phòng Kế toán', 'Thanh toán', 'Debit note · Thanh toán']],
  VTHAILONG: [['Điều độ nhà xe', 'Điều độ', '—'], ['Kế toán nhà xe', 'Thanh toán', '—']],
  SACKYHAIDANG: [['Phòng nhận mẫu', 'Kiểm nghiệm', '—']],
};

const PORTAL_ROWS: Record<string, [string, string, string][]> = {
  YANGMING: [['YM eService', 'eservice.yangming.com', 'hana***']],
  SACKYHAIDANG: [['Cổng tra kết quả', 'portal kiểm nghiệm', 'hana***']],
};

const WIKI_NOTES: Record<string, [string, string, string][]> = {
  YANGMING: [['Cut-off SI', 'Hãng nhận SI qua eService trước 12:00 ngày CloseDoc; sửa sau cut-off tính phí amendment.', 'DAVID · 14/Oct/2026']],
};
const WIKI_FILES: Record<string, [string, string, string, string][]> = {
  YANGMING: [
    ['YML-HD-2026-Q4.pdf', 'Hợp đồng', '1,2 MB', 'DAVID · 01/Oct/2026'],
    ['YML-LCC-Notice-Oct.pdf', 'Bảng giá / thông báo phí', '420 KB', 'PHUONGNKT · 28/Sep/2026'],
  ],
};

const MONTHS = ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'];
const PF_W = [0.26, 0.3, 0.28, 0.31, 0.33, 0.36];

export function partnerView(p: Partner): PartnerView {
  const todo: TodoItem[] = [];
  if (!p.approved) todo.push({ k: `Duyệt hồ sơ đối tác ${p.id}`, who: 'DAVID', due: 'chờ [SAL-MGR] / [ACC-CP]', tone: 'warn', act: 'Duyệt' });
  if (p.dup) todo.push({ k: 'Trùng ShortName / MST với 1 hồ sơ', who: 'DAVID', due: 'cần gộp', tone: 'err', act: 'Gộp' });
  if (!p.type) todo.push({ k: 'Gắn loại đối tác', who: 'DAVID', due: 'thiếu loại', tone: 'warn', act: 'Gắn loại' });
  if (p.contacts === 0) todo.push({ k: 'Thêm liên hệ của đối tác', who: 'DAVID', due: 'chưa có liên hệ', tone: 'warn', act: 'Thêm' });
  for (const b of p.banks) if (!b.verified) todo.push({ k: `Xác minh tài khoản nhận tiền · ${b.bank}`, who: 'HANHNT', due: '[ACC-CP] · maker–checker', tone: 'warn', act: 'Xác minh' });

  const typeK = p.type ? ` · ${p.type}` : ' · chưa gắn loại';
  const perf = MONTHS.map((month, i) => ({ month, n: Math.round(p.jobs * PF_W[i]!) }));
  const last3 = perf.slice(3).reduce((a, r) => a + r.n, 0);
  const prev3 = perf.slice(0, 3).reduce((a, r) => a + r.n, 0);
  const dl = prev3 ? Math.round(((last3 - prev3) / prev3) * 100) : 0;
  const used = p.jobs > 0 ? '21/Oct/2026' : '—';
  return {
    todo,
    legal: [
      ['Loại pháp nhân', 'Tổ chức'], ['MST', p.mst], ['Tên (VN)', p.name], ['Tên (EN)', p.name], ['Địa chỉ', 'TP Hồ Chí Minh · Ho Chi Minh City'],
      ['Vùng · nước · tỉnh', 'Nội địa · Việt Nam · TP Hồ Chí Minh'], ['Điện thoại · fax', '—'], ['Website · email chung', '—'], ['Người tạo', p.id === 'ZALO' ? 'AnNPH · 12/Oct/2026' : 'DAVID · 2024'],
    ],
    info: [
      ['ShortName', p.id], ['MST', p.mst], ['Tên pháp lý', p.name], ['Vai · loại', p.roles.join(' · ') + typeK],
      ['Duyệt', p.approved ? 'Đã duyệt' : 'Chờ duyệt', p.approved ? undefined : 'warn'], ['Blacklist', 'Không'], ['Sử dụng', 'Đang dùng'],
      ['Trùng', p.dup ? 'Trùng ShortName / MST với 1 hồ sơ' : 'Không', p.dup ? 'warn' : undefined],
    ],
    roleChips: [...p.roles.map((k) => ({ k, pri: true })), p.type ? { k: p.type, pri: false } : { k: 'Chưa gắn loại đối tác', pri: false, warn: true }],
    use: [['Dùng trong job 90 ngày', `${p.jobs} job`], ['Lần dùng gần nhất', used], ['Vai trên job', p.carrier ? 'Hãng tàu · Booking' : p.id === 'VTHAILONG' ? 'Nhà xe' : 'Dịch vụ cộng thêm']],
    perf,
    perfKpi: [
      { k: 'Job 90 ngày', v: String(p.jobs), delta: prev3 ? `${dl >= 0 ? '+' : '−'}${Math.abs(dl)}%` : undefined, up: dl >= 0 },
      { k: 'TB / tháng', v: (p.jobs / 3).toFixed(1).replace('.', ',') },
      { k: 'Lần dùng gần nhất', v: used },
    ],
    history: [
      ...(p.approved ? [{ k: 'Duyệt hồ sơ', who: 'DAVID', when: '14/Oct/2026 10:20', tone: 'ok' as const }] : [{ k: 'Tạo hồ sơ · chờ duyệt', who: 'AnNPH', when: '12/Oct/2026 09:02', tone: 'warn' as const }]),
      { k: 'Cập nhật điều khoản thanh toán', who: 'HẠNH', when: '02/Oct/2026 16:10', tone: 'lb' },
      { k: 'Tra lại MST · tình trạng Đang hoạt động', who: 'Hệ thống', when: '01/Oct/2026 00:30', tone: 'lb' },
    ],
    links: [
      { k: 'Công nợ phải trả & phiếu chi', d: 'Mint-Cost · theo kỳ, 12 tháng', ext: true },
      { k: 'Hỏi giá nhà cung cấp', d: 'Mint-RateInquiry · phiếu hỏi giá đối tác', ext: true },
      { k: p.carrier ? 'Local charge của hãng' : 'Biểu giá dịch vụ mua', d: 'Mint-PriceSetup', ext: true },
      ...(p.carrier ? [{ k: 'Refund KB của hãng', d: 'tab Refund · dòng KB · phiếu RFD', ext: false }] : []),
    ],
    bankRows: (BK_ROWS[p.id] ?? []).map((b) => {
      const verified = !!b.vby;
      return {
        bank: b.bank,
        pur: (b.deposit ? 'Deposit (cược)' : 'Cước / thanh toán chung') + (b.def ? ' · mặc định' : ''),
        def: b.def,
        no: b.perDn ? 'Theo từng DN' : maskNo(b.no),
        mode: b.perDn ? 'QR / mã trên từng DN' : 'Số tài khoản cố định',
        holder: b.perDn ? '—' : deAccent(p.name).toUpperCase(),
        verified,
        vs: verified ? b.vby!.split(' · ')[0]! : `Chờ · ${b.by}`,
        vsTip: verified ? `Đã xác minh · ${b.vby}` : `Chờ xác minh · nhập bởi ${b.by}`,
        canVerify: !verified && b.by !== 'DAVID',
        canDef: !b.def,
      };
    }),
    contactRows: (CT_ROWS[p.id] ?? []).map(([name, pos, flags]) => ({ name, pos, flags })),
    lccSets: p.carrier ? [[`RF_${p.id === 'YANGMING' ? 'YANGMING' : 'MSC'}_AMS`, 'Hàng lạnh · có AMS · v4 từ 01/Oct/2026'], ['DC_YANGMING_AMS', 'Hàng khô · có AMS · v3'], ['DC_YANGMING_Non-AMS', 'Hàng khô · không AMS · v3']].map(([code, d]) => ({ code: code!, d: d! })) : [],
    portalRows: (PORTAL_ROWS[p.id] ?? []).map(([k, url, user]) => ({ k, url, user })),
    wikiNotes: (WIKI_NOTES[p.id] ?? []).map(([title, body, meta]) => ({ title, body, meta })),
    wikiFiles: (WIKI_FILES[p.id] ?? []).map(([name, kind, size, meta]) => ({ name, kind, size, meta })),
    people: [['DAVID', '[SAL-MGR] · duyệt hồ sơ'], ['HANHNT', '[ACC-CP] · điều khoản thanh toán, xác minh tài khoản']],
  };
}

declare module '@hana/data' {
  interface Entities {
    crmPartner: Partner;
  }
}
